import React from 'react'
import Layout from './Layout'

const MainLayout = () => {
  return (
    <div>
      <Layout />
    </div>
  )
}

export default MainLayout
